import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, CircularProgress, Container, Stack, TextField, Typography} from '@mui/material'
import AutocompleteInput from '../components/autocomplete';
import ResultsGrid from '../components/results';
import TvControls from '../components/tv';
import Magnet from '../components/magnet';
import getDomain from '../components/domain';
import SeedboxStatus from '../components/status';
import Player from '../components/player';


function Home() {

  const [selection, setSelection] = useState("")
  const [search, setSearch] = useState()

  let debounce
  
  const [status, setStatus] = useState(
    <Stack direction="row" spacing={3} alignContent='center' justifyContent='left'>
      <CircularProgress size={20} />
      <Typography variant='p'>Checking Server Status</Typography>
    </Stack>
  )

  const limit = 30

  const handleSelect = (selection) => {

    var search = selection?.name ?? selection?.title ?? null
    //var id = query?.id
    //search = search.replace(/[^a-zA-Z0-9 ]/g, "");

    //const year = query?.release_date?.split("-")[0] ?? ""

    setSelection(selection)
    setSearch(search)
  }

  const handleTvSelect = (tvQuery) => {
    setSearch(tvQuery)
  }

  const checkStatus = async () => {
      try {
        console.log("Checking Status")
        await fetch(`${getDomain()}/online`, { timeout: 1000 })
        console.log("Online")
        setStatus(<Alert severity="success">Service Online</Alert>)
      } catch (error) {
        offline(error)
      }


  }

  document.title = "Wingate Plex"

  const offline = (e) => {
        console.log('page down *****', e)

        var seconds = 10

        setInterval(() => {

          setStatus( <Alert severity="error">Server is Offline. Please notify <a href="mailto:gates@raptlex.com">gates@raptlex.com</a>. Retrying in {seconds} seconds.</Alert> )
          seconds--

          if (seconds < 0){ window.location.reload()}

        }, 1000)
   }



  useEffect( () => {
    checkStatus()
    if (search === undefined) {setSearch()}
  }, [])


  
  return (
    <Box sx={{padding: '20px', width: '100vw', height: '100vh'}}>
      <title>Wingate Plex</title>
        <Container sx={{maxWidth:'98vw'}}>
          <Stack spacing={5} alignContent="flex-start" justifyContent="flex-start">
            <br></br>
            <Typography variant='h2' fontSize={30}>Wingate Plex Downloader</Typography>
            <Typography>Use this tool to search for and select the best Movie or TV show to download into Plex</Typography>
            {status}
            <br></br>
            <AutocompleteInput callback={handleSelect} />
            <TvControls callback={handleTvSelect} selection={selection} />
            <TextField label="Manual Search"
              onChange={(e) => {
                if (e.target.value) {
                  clearTimeout(debounce);
                  debounce = setTimeout(async () => {
                    setSearch(e.target.value)
                  }, 500);
          
                } 
              }
            }
              />
            <Stack direction='row' spacing={2}>
              <Button variant='contained' href='#popMovies'>Popular Movies</Button>
              <Button variant='contained' href='#popTv'>Popular TV Shows</Button>
            </Stack>
            <ResultsGrid query={search} limit={limit} selection={selection}/>
            <Typography>Or submit a magnet link manually:</Typography>
            <Magnet />
            <SeedboxStatus />
          </Stack>
        </Container>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
    </Box>
  );
}

export default Home;
